import React from 'react';
import { Text } from 'rsuite';
import pluralize from 'pluralize';
import BasicStyledCheckbox from '../../../form/BasicStyledCheckbox';
import TaxReportingStatusIndicator from '../../TaxReportingStatusIndicator';
import { getAddressWithUnitNumber, titleize } from '../../../../common/utils';
import { PaymentPeriod, PeriodLicense } from '../../../../types/tax';
import IconIndicator from '../../../user-feedback/IconIndicator';

interface TaxLicensesTableProps {
  licenses?: Array<PeriodLicense>;
  loading?: boolean;
  period: PaymentPeriod;
  permitType?: string;
  selectAll: (period: PaymentPeriod, isSelected: boolean) => void;
  selectLicense: (licenseNum: string, period: PaymentPeriod) => void;
  selectedLicenses?: Set<string>;
}

export const TaxLicensesTable = ({
  licenses = [],
  loading = false,
  period,
  permitType = '',
  selectAll,
  selectLicense,
  selectedLicenses = new Set<string>(),
}: TaxLicensesTableProps) => {
  if (loading) {
    return <IconIndicator />;
  }
  if (licenses?.length === 0) {
    return <Text>No {pluralize(permitType)} available for this period</Text>;
  }
  return (
    <table className="tax-table">
      <thead>
        <tr className="tax-column-heading-row">
          <th scope="col">
            <BasicStyledCheckbox
              label=""
              onChange={(checked: boolean) => {
                selectAll(period, checked);
              }}
            />
          </th>
          <th scope="col">Address</th>
          <th scope="col">{permitType} Number</th>
          <th scope="col">Tax Reporting This Period</th>
          <th scope="col">Owner&apos;s Name</th>
        </tr>
      </thead>
      <tbody className="tax-license-row-wrapper">
        {licenses.map((license, index) => (
          <tr
            key={`license_${index}`}
            className="tax-license-row"
            data-cy={`license-row-${license.license}`}
          >
            <td>
              <BasicStyledCheckbox
                label=""
                onChange={() => {
                  selectLicense(license.license ?? '', period);
                }}
                checked={selectedLicenses.has(license.license ?? '')}
              />
            </td>
            <td className="select-properties-address">
              {getAddressWithUnitNumber(license.address, license.unitNumber)}
            </td>
            <td>{license.license}</td>
            <td>
              <TaxReportingStatusIndicator status={license.totPaidStatus} />
              {titleize(license.totPaidStatus ?? '')}
            </td>
            <td>{license.ownerName}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
